import { combineReducers } from 'redux';

import { FEATURE_NAME as AUTH } from 'containers/authorization/consts';
import auth from 'containers/authorization/reducer';

import { FEATURE_NAME as POSTS } from 'containers/posts/consts';
import posts from 'containers/posts/reducer';

export default combineReducers({ [AUTH]: auth, [POSTS]: posts });
